// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"5e78e12d","155":"9f8dfa3a","304":"759b1bdc","366":"a55b02b2","432":"483d54a5","469":"fe62152f","699":"5bb59a32","739":"cd15a118","834":"ea809bfe","880":"5e1fa614","917":"2359423f","929":"8610e7fb","967":"26437194"}[chunkId] + ".chunk.js";
};